import { z } from 'zod';

/**
 * The compliance gate's modes — the single source; `@cp/core/media-compliance`
 * re-exports it as `MEDIA_COMPLIANCE_MODES`, the api/worker env schemas read it.
 *
 * `off` (tesztkör-4, 2026-09-22): the rights layer disappears from the product
 * surface — no questions on upload, no badges, no gate. The columns and the
 * engine stay, so it can be switched back on without a migration.
 */
export const MediaComplianceModeSchema = z.enum(['enforce', 'advisory', 'off']);
export type MediaComplianceMode = z.infer<typeof MediaComplianceModeSchema>;

/**
 * `GET /features` — the server-side switches the SPA has to know about to
 * shape its own gates. Read-only, per deployment (not per user or org).
 */
export const AppFeaturesSchema = z.object({
  mediaComplianceMode: MediaComplianceModeSchema,
});
export type AppFeatures = z.infer<typeof AppFeaturesSchema>;
